<template>
  <div style="padding-top: 20px;padding-left: 20px;">
    <div style="display: flex;flex-wrap: wrap;">
      <div>
        <div style="font-weight: 600;font-size: 14px;margin-top: 5px;">最新轮次：</div>
        <div class="main" style="margin-top: 10px;margin-right: 30px;">
            <div style="font-size: 13px;margin-right: 10px;">编号：{{ newestRecord.sn }}</div>
            <div style="font-weight: 900;color: #66CC84;" v-if="newestRecord.status == 0">投入中</div>
            <div style="font-weight: 900;color: red;" v-if="newestRecord.status == 1">已开奖</div>
            <div style="font-size: 13px;margin-left: 10px;">{{ newestRecord.remainSecond }}秒</div>
        </div>
        <div style="font-size: 13px;margin-right: 10px;margin-top: 10px;margin-bottom: 10px;">格子数据：</div>
        <div>
            <el-table
          ref="gridTable"
          v-loading="loading1"
          :data="buyList"
          tooltip-effect="dark" 
          :stripe="true" 
          :border="true"
          style="width: 391px"
          size="mini"
        >
          <el-table-column prop="grid" label="格子" width="40" />
          <el-table-column prop="buyCount" label="购买笔数" width="60" />
          <el-table-column prop="buyAmount" label="购买金额" width="80" />
          <el-table-column prop="rbCount" label="机器笔数" width="50" />
          <el-table-column prop="rbAmount" label="机器人金额" width="80" />
          <el-table-column prop="financialDay" label="合计金额" width="80">
          <template slot-scope="scope">
            <div>{{ (Number(scope.row.buyAmount) + Number(scope.row.rbAmount)).toFixed(2) }}</div>
          </template>
        </el-table-column> 
         
        </el-table>
        </div>
        <div class="flex_title" style="margin-top: 20px;margin-bottom: 20px;">以下保存需要操作快点，每秒会刷新一次</div>
        <div class="main" style="font-size: 13px;margin-bottom: 20px;">
            <div>1、本局强制杀格子：</div>
            <el-input style="width:70px;margin-left: 10px;" v-model="focusGrid" placeholder="1-13"/>
            <el-button type="primary" class="edit-button" style="margin: 0 10px;" size="mini" @click="updateForcedGrid()">锁定</el-button>
            <div>填0或者不填表示不生效</div>
        </div>
        <div class="main" style="font-size: 13px;margin: 20px 0;">
            <div>2、自动随机杀投入金额最多前几位</div>
            <el-input style="width:70px;margin-left: 10px;" v-model="randomKillCount" placeholder="1-13"/>
            <el-button type="primary" class="edit-button" style="margin: 0 10px;" size="mini" @click="updateForcedGrid1()">确定</el-button>
            <div>填0或者不填表示不生效</div>
        </div>
      </div>
      <!-- 右边 -->
      

      <div >
        <div class="">
          <div class="flex_title">注意：</div>
          <div class="flex_title">以下改动成功后只对下局生效，已开局无效</div>
        </div>
        <div style="font-weight: 600;font-size: 14px;margin-top: 5px;">每局机器人总数范围：</div>
        <div class="main" style="margin-top: 5px;">
            <el-input style="width:100px;margin-right: 10px;" v-model="active.rbMin" placeholder="请输入范围"/>
            ~
            <el-input style="width:100px;margin-left: 10px;" v-model="active.rbMax" placeholder="请输入范围"/>
        </div>
        <div style="font-weight: 600;font-size: 14px;margin-top: 5px;">每局中间熊每秒额外减少数</div>
        <div class="main" style="margin-top: 5px;">
            <el-input style="width:100px;margin-right: 10px;" v-model="active.dmin" placeholder="请输入范围"/>
            ~
            <el-input style="width:100px;margin-left: 10px;" v-model="active.dmax" placeholder="请输入范围"/>
        </div>
        <div style="font-weight: 600;font-size: 14px;margin-top: 15px;">每个机器人行为权重：</div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">不购买权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight0" placeholder="请输入不购买权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第1格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight1" placeholder="请输入购买第1格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第2格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight2" placeholder="请输入购买第2格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第3格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight3" placeholder="请输入购买第3格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第4格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight4" placeholder="请输入购买第4格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第5格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight5" placeholder="请输入购买第5格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第6格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight6" placeholder="请输入购买第6格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第7格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight7" placeholder="请输入购买第7格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第8格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight8" placeholder="请输入购买第8格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第9格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight9" placeholder="请输入购买第9格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第10格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight10" placeholder="请输入购买第10格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第11格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight11" placeholder="请输入购买第11格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第12格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight12" placeholder="请输入购买第12格权重"/>
        </div>
        <div class="main" style="margin-top: 5px;">
            <div class="flex_main_name">购买第13格权重</div>
            <el-input style="width:100px;margin-left: 10px;" v-model="active.weight13" placeholder="请输入购买第13格权重"/>
        </div>
        <div style="margin-left: 110px; margin-top: 20px">
      <el-popconfirm title="确定更新？" @confirm="tieImageUpdate()">
        <el-button slot="reference" type="primary" class="edit-button"
          >更新</el-button
        >
      </el-popconfirm>
    </div>

      </div>
    </div>
    
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap, UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: {},
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], //
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      name: "",
      username: "",
      memo: "",
      isLinkLock: false,
      focusGrid:'',
      randomKillCount:'',
      isVipLinkLock: false,
      newestRecord:{},
      buyList:[],
      time:null,
      loading1:false
    };
  },
  mounted() {
    this.getList();
    clearInterval(this.time)
    this.time = setInterval(()=>{
        this.newest();
    },1000)
  },
  destroyed(){
    clearInterval(this.time)
  },
  methods: {
    newest(){
        this.$api.operate
        .escapeConfigNewest()
        .then((res) => {
          if(this.newestRecord.sn != res.sn){
            this.focusGrid = res.focusGrid
            this.randomKillCount = res.randomKillCount
          }
          this.newestRecord = res;
          this.buyList = res.buyList;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateForcedGrid(){
        this.$api.operate
        .updateForcedGrid({
            sn:this.newestRecord.sn,
            grid:this.focusGrid
        })
        .then((res) => {
          this.$message.success(res);

        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateForcedGrid1(){
        this.$api.operate
        .updateForcedRandomGrid({
            sn:this.newestRecord.sn,
            randomKillCount:this.randomKillCount
     })
        .then((res) => {
           this.$message.success(res);

        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      this.$api.operate
        .escapeConfigView()
        .then((res) => {
          this.active = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新
    tieImageUpdate() {
      this.$api.operate
        .escapeConfigUpdate(this.active)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
          this.getList();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex_main {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.flex_main_name {
  width: 100px;
  text-align: end;
  margin-right: 0px;
  font-size: 14px;
  color: #000;
}
.flex_title {
  text-align: start;
  font-size: 12px;
  color: red;
  font-weight: 600;
}
.flex_title1 {
  font-size: 15px;
  font-weight: 500;
}
.main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
